// extracted by mini-css-extract-plugin
export default {"copy":"OrderSuccess_copy__U3Ynw"};